
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const LaserFacial = () => {
  const treatmentData = {
    title: "Laser Facial",
    subtitle: "Advanced laser technology for skin resurfacing and renewal",
    description: "Our laser facial treatments use cutting-edge technology to address skin concerns from the inside out. Stimulate collagen production and achieve smoother, more youthful-looking skin.",
    whoItsFor: [
      "Those with fine lines and wrinkles",
      "People with sun damage or age spots",
      "Anyone seeking skin tightening",
      "Clients with acne scars",
      "Those wanting overall skin rejuvenation"
    ],
    packages: [
      {
        name: "Laser Resurfacing",
        visitorPrice: "$500",
        memberPrice: "$450",
        description: "Full face laser treatment for comprehensive renewal"
      },
      {
        name: "Targeted Laser",
        visitorPrice: "$300",
        memberPrice: "$270",
        description: "Focused treatment for specific problem areas"
      },
      {
        name: "Laser Series",
        visitorPrice: "$1,350",
        memberPrice: "$1,215",
        description: "Package of 3 treatments for optimal results"
      }
    ],
    beforeCare: [
      "Avoid sun exposure for 2 weeks",
      "Discontinue retinoids 1 week prior",
      "No self-tanning products",
      "Arrive with clean, makeup-free skin"
    ],
    duringCare: [
      "Topical numbing for comfort",
      "Precise laser application",
      "45-60 minute treatment time",
      "Cool air for comfort during treatment"
    ],
    afterCare: [
      "Apply healing ointment as directed",
      "Avoid sun exposure for 2 weeks",
      "Gentle skincare routine only",
      "Results improve over 2-3 months"
    ],
    memberPerks: [
      "10% discount on all laser treatments",
      "Complimentary post-treatment skincare",
      "Free consultation to determine best laser type",
      "Priority booking for series packages",
      "Access to professional healing products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default LaserFacial;
